import React, { useContext } from "react";
import Button from "../../VibehutUI/Button";
import { useHistory } from "react-router-dom";
import globals from "../../globals";
import { StoreContext } from "../../Context/StoreContext";
import { getPromotedPartners } from "../../actions/partnerAction";
import { PartnerCard } from "../partners/PartnerCard";

function RecordedCallModal() {
  const { state, dispatch } = useContext(StoreContext);
  const {
    partner: { partners, offset, isFetching },
  } = state;
  const history = useHistory();
  const handleSubmit = () => {
    history.push("/calls");
    globals.hideModal();
  };

  const handleSeeMore = () => {
    getPromotedPartners(dispatch, offset);
  };

  return (
    <div className="bg-white text-gray-600 dark:text-gray-300 dark:bg-navyGray p-4 relative">
      <div className="flex flex-col justify-center items-center">
        <p>Your call has been recorded.</p>
        <p>You can download and publish it.</p>
        <div className="pt-3 flex flex-row-reverse">
          <Button
            size="vibhut-sm"
            variant="vibhut-primary"
            onClick={handleSubmit}
          >
            Go to Calls
          </Button>

          <div className="mr-2">
            <Button
              size="vibhut-sm"
              variant="vibhut-secondary"
              onClick={() => {
                globals.hideModal();
              }}
            >
              Skip for now
            </Button>
          </div>
        </div>
        <div className="call-recorded text-white rounded-xl mt-4 p-3">
          <div className="flex flex-col pl-3">
            <h3 className="font-bold  ">
              Editing is a lot easier with the right tools
            </h3>
            <p className="text-xs font-normal">
              You created the content, now use the best software and services to
              make it stand out.
            </p>
          </div>
        </div>
        <div className="flex flex-col w-full h-full justify-items-center items-center align-middle gap-2 pt-[20px]">
          {partners &&
            partners.map((partner, index) => {
              return <PartnerCard partner={partner} key={index} />;
            })}
          {offset && (
            <div className="flex w-full h-full justify-center align-middle">
              {" "}
              <Button
                size="vibhut-sm"
                variant="vibhut-secondary"
                onClick={() => {
                  handleSeeMore();
                }}
              >
                {isFetching ? "Loading..." : "See More"}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RecordedCallModal;
